import { IStatusPaymentItem } from "./status-payment-item.interface";

export interface IStatusPayment {
  dealer: IStatusPaymentItem;
  pending: IStatusPaymentItem;
  approved: IStatusPaymentItem;
  rejected: IStatusPaymentItem;
  refunded?: IStatusPaymentItem;
  cancelled?: IStatusPaymentItem;
}
